import { Badge } from '@/shared/ui/badge'
import { t } from '@/shared/lib/i18n'

interface Props {
  code: string | null
}

const ReviewTypeBadge = ({ code }: Props) => {
  switch (code) {
    case 'CNM':
      return (
        <Badge variant="warning">{t('compliance.dashboard.resolutionType.confirmTheMiss')}</Badge>
      )
    case 'ODE':
      return (
        <Badge variant="destructive">{t('compliance.dashboard.resolutionType.override')}</Badge>
      )
    case 'NPT':
      return (
        <Badge variant="secondary">{t('compliance.dashboard.resolutionType.notPerformed')}</Badge>
      )
    case 'OFL':
      return <Badge variant="secondary">{t('compliance.dashboard.resolutionType.offline')}</Badge>
    default:
      return <Badge variant="outline">{t('compliance.dashboard.resolutionType.pending')}</Badge>
  }
}

export default ReviewTypeBadge
